import { useCallback, useEffect, useState } from 'react';
import { getWebPushState, registerWebPush, unregisterWebPush, type WebPushState } from '../lib/webpush';

export function useWebPush(actorId?: string) {
  const [state, setState] = useState<WebPushState>('registering');

  useEffect(() => {
    if (!actorId) return;
    let cancelled = false;
    void registerWebPush(false).then((next) => {
      if (!cancelled) setState(next);
    });
    return () => {
      cancelled = true;
    };
  }, [actorId]);

  const enable = useCallback(async () => {
    setState('registering');
    const next = await registerWebPush(true);
    setState(next);
  }, []);

  const disable = useCallback(async () => {
    setState('registering');
    await unregisterWebPush();
    setState(await getWebPushState());
  }, []);

  return { state, enable, disable };
}
